import React from 'react';
import { FormattedMessage } from 'react-intl';
import { responseError } from '@/utils/errors';
import NegativeToast from '@/components/toasts/NegativeToast';

const SaveWithDatasourceErrorToast = ({ title, error }) => (
  <NegativeToast className="aridhia-create-with-datasource-error-toast" icon="times circle">
    <FormattedMessage
      id="dataset.saved.datasource.error"
      values={{ title, error: responseError({ error }).message }}
    />
  </NegativeToast>
);

export default SaveWithDatasourceErrorToast;
